<div class="forward-dialog flex flex-col">
    <h2 class="forward-title">Forward message</h2>
    <p class="forward-preview" [innerHtml]="data.preview"></p>

    <div class="forward-search flex flex-row items-center">
        <i class="far fa-magnifying-glass" aria-hidden="true"></i>
        <input type="search" [(ngModel)]="searchText" placeholder="Search conversations"
               aria-label="Search conversations" cdkFocusInitial>
    </div>

    <div class="forward-list simple-scroll" role="listbox" aria-multiselectable="true" aria-label="Conversations">
        <button type="button" class="forward-row flex flex-row items-center" role="option"
                *ngFor="let conversation of visibleConversations; trackBy: trackById"
                [class.selected]="selected.has(conversation.id)" [attr.aria-selected]="selected.has(conversation.id)"
                (click)="toggle(conversation)">
            <collaboration-avatar [gravatarInfo]="conversation.titleAvatarInfo"
                                  [showCaseAvatar]="conversation.sourceType === 'DAC6'"
                                  [showGroupAvatar]="conversation.isGroupConversation"></collaboration-avatar>
            <span class="forward-name">{{conversation.title}}</span>
            <i class="forward-check" aria-hidden="true"
               [ngClass]="selected.has(conversation.id) ? 'fa-solid fa-circle-check' : 'far fa-circle'"></i>
        </button>
        <p class="forward-empty" *ngIf="!visibleConversations.length">No conversations found</p>
    </div>
</div>
<mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
    <button mat-button class="orbitax-footer-button" (click)="onCancel()">Cancel</button>
    <button mat-button class="orbitax-footer-action-button" [disabled]="!selected.size" (click)="onForward()">
        Forward{{selected.size ? ' (' + selected.size + ')' : ''}}
    </button>
</mat-dialog-actions>
